export const CERTIFICATE_FIELD_KEYS = [
  { key: 'title', label: 'Title', minWidth: 50, minHeight: 8 },
  { key: 'subtitle', label: 'Subtitle', minWidth: 50, minHeight: 6 },
  { key: 'statement', label: 'Statement', minWidth: 50, minHeight: 8 },
  { key: 'companyName', label: 'Company Name', minWidth: 40, minHeight: 8 },
  { key: 'companyAddress', label: 'Company Address', minWidth: 40, minHeight: 8 },
  { key: 'certificateNumber', label: 'Certificate Number', minWidth: 32, minHeight: 7 },
  { key: 'standardsText', label: 'Standards', minWidth: 40, minHeight: 8 },
  { key: 'scopeText', label: 'Scope', minWidth: 50, minHeight: 12 },
  { key: 'verificationText', label: 'Verification', minWidth: 50, minHeight: 12 },
  { key: 'datesBlock', label: 'Dates', minWidth: 40, minHeight: 14 },
  { key: 'signatureBlock', label: 'Signature Block', minWidth: 36, minHeight: 16 },
  { key: 'remarks', label: 'Remarks', minWidth: 40, minHeight: 8 },
];

export const CERTIFICATE_PAGE_SIZES_MM = {
  a4: { width: 210, height: 297 },
  a3: { width: 297, height: 420 },
};

export const DEFAULT_CERTIFICATE_COORDINATES = {
  title: { x: 26, y: 94, width: 244, height: 14, align: 'left', fontSize: 34 },
  standardsText: { x: 26, y: 110, width: 244, height: 18, align: 'left', fontSize: 51 },
  subtitle: { x: 26, y: 129, width: 244, height: 10, align: 'left', fontSize: 20 },
  statement: { x: 26, y: 145, width: 205, height: 9, align: 'left', fontSize: 12 },
  companyName: { x: 25, y: 157, width: 230, height: 24, align: 'left', fontSize: 33 },
  companyAddress: { x: 25.5, y: 172, width: 205, height: 18, align: 'left', fontSize: 14 },
  scopeText: { x: 25.5, y: 207, width: 205, height: 42, align: 'left', fontSize: 16 },
  verificationText: { x: 25.5, y: 220, width: 205, height: 22, align: 'left', fontSize: 16 },
  signatureBlock: { x: 23.5, y: 273, width: 95, height: 16, align: 'left', fontSize: 15 },
  certificateNumber: { x: 25.5, y: 339.5, width: 115, height: 9, align: 'left', fontSize: 17 },
  datesBlock: { x: 25.5, y: 359, width: 145, height: 28, align: 'left', fontSize: 16 },
  remarks: { x: 25.5, y: 389, width: 247, height: 20, align: 'left', fontSize: 10.2 },
};

export const PAGE_LIMITS_MM = CERTIFICATE_PAGE_SIZES_MM.a3;

const toNumber = (value, fallback = 0) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : fallback;
};

export const clampCoordinateField = (field = {}, pageLimits = PAGE_LIMITS_MM) => {
  const width = Math.max(1, toNumber(field.width, 1));
  const height = Math.max(1, toNumber(field.height, 1));
  return {
    ...field,
    x: Math.min(Math.max(0, toNumber(field.x)), Math.max(0, pageLimits.width - width)),
    y: Math.min(Math.max(0, toNumber(field.y)), Math.max(0, pageLimits.height - height)),
    width: Math.min(width, pageLimits.width),
    height: Math.min(height, pageLimits.height),
    fontSize: Math.max(4, toNumber(field.fontSize, 9)),
    align: ['left', 'center', 'right'].includes(field.align) ? field.align : 'left',
  };
};

export const normalizeCertificateCoordinateLayout = (layout = {}) => {
  const pageSize = CERTIFICATE_PAGE_SIZES_MM[layout.pageSize] || CERTIFICATE_PAGE_SIZES_MM.a3;
  const fields = {
    ...DEFAULT_CERTIFICATE_COORDINATES,
    ...(layout.fields || {}),
  };
  return {
    enabled: !!layout.enabled,
    pageSize: layout.pageSize || 'a3',
    fields: Object.fromEntries(
      CERTIFICATE_FIELD_KEYS.map(({ key }) => [
        key,
        clampCoordinateField({
          ...DEFAULT_CERTIFICATE_COORDINATES[key],
          ...(fields[key] || {}),
        }, pageSize),
      ]),
    ),
  };
};

export const updateCoordinateField = (layout, fieldKey, patch) => {
  const normalized = normalizeCertificateCoordinateLayout(layout);
  return {
    ...normalized,
    fields: {
      ...normalized.fields,
      [fieldKey]: clampCoordinateField({
        ...normalized.fields[fieldKey],
        ...patch,
      }),
    },
  };
};

export const nudgeCoordinateField = (layout, fieldKey, deltaX, deltaY) => {
  const normalized = normalizeCertificateCoordinateLayout(layout);
  const field = normalized.fields[fieldKey] || DEFAULT_CERTIFICATE_COORDINATES[fieldKey];
  return updateCoordinateField(normalized, fieldKey, {
    x: field.x + deltaX,
    y: field.y + deltaY,
  });
};
